import React from 'react'
import { ImageUpload } from 'web/src/app/reports/partials'
import { Box } from '@material-ui/core'
import { useStyles } from './images-section-styles'

export const ImagesSection = ({
    imagesForUpload,
    setImagesForUpload,
    setDeletedPictureKeys,
    deletedPictureKeys,
    isEdit
}) => {
    const classes = useStyles()

    return (
        <Box className={classes.container}>
            {imagesForUpload?.map((item, index) => {
                return (
                    <ImageUpload
                        key={index}
                        imagesForUpload={imagesForUpload}
                        setImagesForUpload={setImagesForUpload}
                        setDeletedPictureKeys={setDeletedPictureKeys}
                        deletedPictureKeys={deletedPictureKeys}
                        data={item}
                        indexOfCommentCard={index}
                        isEdit={isEdit}
                    />
                )
            })}

            {imagesForUpload?.length < 5 && (
                <ImageUpload
                    imagesForUpload={imagesForUpload}
                    setImagesForUpload={setImagesForUpload}
                />
            )}
        </Box>
    )
}
